import _get from 'lodash/get'

import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import { FAILURE_REASONS } from './constants'
import type { GetFailureReason } from './types'

const getContentsDeFailureReason: GetFailureReason = ({
  formValues,
  stepTransformer = (step: string) => step,
  currentStep,
}) => {
  const { getParamPath } = generateGetFlowValueFunctions('contents_v1_getsafe_de')

  switch (currentStep) {
    case stepTransformer('contents_damages'): {
      const selectedNumberOfPreviousClaims = _get(
        formValues,
        getParamPath('number_of_claims_in_last_5y')
      )
      return {
        reason: FAILURE_REASONS.TOO_MANY_PREVIOUS_CLAIMS,
        extraData: { selectedNumberOfPreviousClaims },
      }
    }
    case stepTransformer('contents_insurance_cancelled'): {
      const cancelledByPreviousInsurer = _get(
        formValues,
        getParamPath('cancelled_by_previous_insurer')
      )
      return {
        reason: FAILURE_REASONS.PREVIOUS_INSURANCE_VOIDED,
        extraData: { cancelledByPreviousInsurer },
      }
    }
    case stepTransformer('contents_permanent_residence'): {
      const permanentResidenceInGermany = _get(
        formValues,
        getParamPath('permanent_residence_in_germany')
      )
      return {
        reason: FAILURE_REASONS.PRIMARY_RESIDENCE_NOT_GERMANY,
        extraData: { permanentResidenceInGermany },
      }
    }
    default: {
      break
    }
  }
}
export default getContentsDeFailureReason
